/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 05.07.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import Map from './Map';
import GeometryInputPlugin from '../plugins/GeometryInputPlugin';
import SearchPlugin from '../plugins/SearchPlugin';
import CoordinatesSearchPlugin from '../plugins/CoordinatesSearchPlugin';
import LayerChooserPlugin from '../plugins/LayerChooserPlugin';
import LayerInfoPlugin from '../plugins/LayerInfoPlugin';
import DrawerPlugin from '../plugins/DrawerPlugin/DrawerPlugin';

const GeometryEditControl = props => {
    const { geometry, plugins = [], type, handleGeometryChange, allowMultipleGeometries = false } = props;

    const newPlugins = [
        SearchPlugin,
        CoordinatesSearchPlugin,
        ...plugins,
        LayerChooserPlugin,
        LayerInfoPlugin,
        'map/plugins/SituationMapPlugin',
        allowMultipleGeometries ? DrawerPlugin : GeometryInputPlugin
    ];

    const geoEditProps = allowMultipleGeometries
        ? {
            drawerGeoJSON: geometry,
            drawerPluginTextLabel: false,
            drawerPluginColorPicker: false,
            onDrawerChange: handleGeometryChange
        }
        : {
            geometry: geometry,
            type: type,
            onGeometryChange: handleGeometryChange
        };

    return (
        <Map
            className="leaflet-draw-horizontal"
            {...props}
            defaultFallbackMapConfigType={'static'}
            plugins={newPlugins}
            {...geoEditProps}
        />
    );
};

GeometryEditControl.propTypes = {
    ...Map.propTypes,

    geometry: PropTypes.object,
    type: PropTypes.string,
    handleGeometryChange: PropTypes.func,
    allowMultipleGeos: PropTypes.bool
};

export default GeometryEditControl;



// WEBPACK FOOTER //
// ./js/components/GeometryEditControl.jsx